<template>
<div class="grid"  @click="edit">
<div class="col-3 md:col-2">
<p class="click_edit_value_title">{{title}}:</p>
</div>


<template v-if="editing">
<div class="col-9 md:col-10 mt-0">
<div class="grid"  v-click-away="clickAway">
<div class="col">

<template v-if="inputdata">
	<ColorPicker v-model="inputdata" @hide="submitChanges" class="mt-3"/>

	<InputText  type="text" v-model="inputdata" class="ml-2 p-inputtext-sm animate_class"  v-on:keyup.enter="submitChanges"  v-on:keyup.esc="cancel" ref="inputarea"  />

</template>
<template v-else>
	<Button type="button"  icon="pi pi-check" label="Renk Atayın" @click="addColor" class="p-button-primary mt-3 pt-1 pb-1 p-button-outlined p-button-sm mr-2"   />
</template>




</div>
<div class="col-fixed " style="width:110px">
<Button type="button"  icon="pi pi-check" @click="submitChanges" class="p-button-primary p-button-outlined p-button-sm mr-2"  :loading="$store.state.ui.submitting" />
<Button type="button"  icon="pi pi-times" @click="cancel" class="p-button-danger p-button-outlined p-button-sm "  :loading="$store.state.ui.submitting" />
</div>
</div>
</div>
</template>

<template v-if="!editing">	
<div class="col-9 md:col-10">
<p class="click_edit_value animate_class" v-if="value">
<span class="color_square" :style="'background-color:#'+value"></span> <span class="color_square_text">{{value}}</span>
</p>

<p class="click_edit_value animate_class" v-else>
Renk Belirlenmemiş
</p>
</div>
</template>

</div>	
</template>

<script>
export default {

  name: 'ClickEditColorPicker',
  props:["title","value","valkey"],
  data () {
    return {
    	editing:false,
    	inputdata:null,
    }
  },
  computed:{

  },
  watch:{
  	value(nevVal,oldVal)
  	{
  		 console.log("value change");
  		 this.editing = false
  	}
  },
  mounted()
  {
  	console.log("ClickEditColorPicker")
  	console.log(this.value)
  },
  methods:{
  	addColor()
  	{
  		this.$emit("addColor",{key:this.valkey})
  	},
  	submitChanges()
  	{

  		if(this.inputdata !==this.value)
  		{
  			this.$emit("dataChanged",{value:this.inputdata,key:this.valkey})
  			//this.cancel()
  		}
  		else
  		{
  			this.cancel()
  		}
  		
  	},
  	clickAway()
  	{
  		if(this.inputdata !==this.value)
  		{
  			//this.$emit("dataChanged",{value:this.inputdata,key:this.valkey})
  			//this.cancel()
  		}
  		else
  		{
  			this.cancel()
  		}
  	},
  	edit()
  	{
      if(!this.editing)
      {
        this.editing = true
        this.inputdata = this.value
        
        setTimeout(()=>{
          if(this.$refs.inputarea)
          {
            this.$refs.inputarea.$el.focus()
          }
          
        },10)
      }
  		
  		
  	},
  	cancel()
  	{
  		setTimeout(()=>{
  			this.editing = false
  		},10)
  		
  	},

  }
};
</script>

<style lang="css" scoped>
.color_square{
	width: 1rem;
	height: 1rem;
	border-radius: 2px;
	cursor: pointer;
	display: inline-block;
	margin-right: 4px;
}
.color_square_text{
	display: inline-block;
	vertical-align: top;
}
</style>